<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="订单号/订单标题/姓名/手机号"
            />
          </el-form-item>
          <el-form-item label="">
            <el-select
              filterable
              v-model="queryForm.step"
              placeholder="订单状态"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button
              icon="el-icon-tickets"
              type="primary"
              @click="exportData"
            >
              导出
            </el-button>
          </el-form-item> -->
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="订单号"
        prop="basic.orderNo"
        show-overflow-tooltip
        width="150"
      />
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="商品数量"
        prop="extra.count"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="订单金额" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.amount && row.amount && row.amount.payAmount }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="退款金额" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.amount && row.amount && row.amount.refundAmount }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人姓名"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.name }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人手机号"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.tel }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="支付方式"
        show-overflow-tooltip
        :formatter="formatChannel"
      />
      <el-table-column align="left" label="订单状态" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag type="primary" v-if="row.step == 1">待付款</el-tag>
          <el-tag type="success" v-if="row.step == 2">已付款</el-tag>
          <el-tag type="warning" v-if="row.step == 3">待收货</el-tag>
          <el-tag type="warning" v-if="row.step == 4">已核销</el-tag>
          <el-tag type="danger" v-if="row.step == 5">已退款</el-tag>
          <el-tag type="info" v-if="row.step == 6">已取消</el-tag>
          <el-tag type="warning" v-if="row.step == 8">退款中</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleShow(row)">
            详情
          </el-button>
          <el-button
            v-if="checkOrderRefund(row)"
            type="text"
            @click="handelRefund(row)"
            class="mr-10"
          >
            退款
          </el-button>
          <!-- <el-button
            v-if="checkVerify(row)"
            type="text"
            @click="handleShip(row)"
            class="mr-10"
          >
            核销
          </el-button> -->
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <detail ref="show" />
    <product-refund ref="productRefund"></product-refund>
  </div>
</template>

<script>
import moment from 'moment'
import { findOrderList } from '@/api/food'
import { orderChannels, orderChannelOptions, orderSteps } from '@/utils/const'
import ProductRefund from './refund.vue'
import {
  filterPrice,
  checkOrderVerify,
  checkOrderRefund,
  checkRefundAmount,
} from '@/utils/tool'
import Detail from './detail.vue'
export default {
  name: 'FoodOrder',
  components: { Detail, ProductRefund },
  data() {
    return {
      moment,
      list: [],
      checkOrderRefund,
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      options: orderSteps,
      queryForm: {
        page: 1,
        size: 10,
        typehood:4,
        keyword: '',
        step: '',
        date: null,
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/food/order') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    async exportData() {
      this.listLoading = true
      const form = Object.assign({}, this.queryForm)
      const date = form.date
      if (date) {
        form.startDate = date[0]
        form.endDate = date[1]
        form.periodMode = 1
      } else {
        form.startDate = ''
        form.endDate = ''
      }
      delete form.date
      delete form.page
      delete form.size
      const res = await exportOrder(form)
      this.listLoading = false
      if (!res) return
      this.$alert(`下载地址：${res.url}`, '门票订单导出', {
        confirmButtonText: '下载',
        callback: (action) => {
          if (action == 'confirm') {
            window.location.href = res.url
          }
        },
      })
    },
    checkVerify(row) {
      return checkOrderVerify(row)
    },
    handelRefund(row) {
      this.$refs.productRefund.showRefund(
        (row.basic && row.basic.dishList) || [],
        row
      )
    },
    handleShip() {},
    handleCommand(command) {
      switch (command.cmd) {
        case 'edit':
          this.handleEdit(command.item)
          break
        case 'delete':
          this.handleDelete(command.item)
          break
      }
    },
    // 格式化订单支付方式
    formatChannel(row) {
      const channel = (row && row.payment && row.payment.channel) || 'UNKOWN'
      return orderChannels[channel]
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handleShow(row) {
      this.$refs['show'].show(row)
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findOrderList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
.vab-query-form {
  :deep() {
    .el-form-item + .el-form-item {
      margin: 0 0 10px 10px !important;

      .el-button {
        margin: 0 0 0 0 !important;
      }
    }
  }
}
</style>
